import React from "react";

const TextAreaField = ({ id, name, value, onChange, placeholder }) => {
  return (
    <textarea
      id={id}
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      rows="5"
      className={`w-full px-4 py-3 bg-transparent border rounded-md focus:outline-none focus:ring-2 focus:ring-white resize-none font-normal text-[16px] md:text-[20px] leading-[100%] tracking-[0%] ${
        value ? "border-white" : "border-[#7D7D7D]"
      }`}
    ></textarea>
  );
};

export default TextAreaField;
